import { EmployeeRecord, TeamRecord } from './OrganizationImport';

export const filterEmptyEmployees = (employees: EmployeeRecord[]) => {
  return employees.filter((employee) => !isEmployeeEmpty(employee));
};

export const isEmployeeEmpty = (employee: EmployeeRecord) => {
  return (
    employee.firstname === '' &&
    employee.surname === '' &&
    employee.team === '' &&
    employee.email === '' &&
    employee.otherEmail === '' &&
    employee.countryCallingCode === '' &&
    employee.phoneNumber === '' &&
    employee.managerOfTeam.length === 0
  );
};

export const filterEmptyTeams = (teams: TeamRecord[]) => {
  return teams.filter((team) => {
    return !(team.id === '' && team.name === '' && team.supervisorTeam === '');
  });
};
